import React from "react";
import "./ColorKeys.scss";

function Key({ content, i }) {
  return (
    <div className="key" key={i}>
      <svg className="key__circle" data-name="Layer 1" viewBox="0 0 16 16">
        <circle className={`key__circle ${content.fill}`} cx="8" cy="8" r="8" />
      </svg>

      {content.text2 ? (
        <p className="key__text">
          {content.text}
          <br />
          {content.text2}
        </p>
      ) : (
        <p className="key__text">{content.text}</p>
      )}
    </div>
  );
}

export default Key;
